<template>
  <div class="perfil-view">
    <h2>Mi Perfil</h2>
    <div v-if="usuario" class="card">
      <div class="card-header">
        Información del Usuario
      </div>
      <div class="card-body">
        <p><strong>Nombre:</strong> {{ usuario.Nombre }}</p>
        <p><strong>ID de Usuario:</strong> {{ usuario.UsuarioId }}</p>
        <p><strong>Email:</strong> {{ usuario.Email }}</p>
      </div>
    </div>

    <div class="card mt-4">
      <div class="card-header">
        Cambiar Contraseña
      </div>
      <div class="card-body">
        <form @submit.prevent="cambiarPassword">
          <div class="mb-3">
            <label for="currentPassword" class="form-label">Contraseña Actual</label>
            <input type="password" class="form-control" id="currentPassword" v-model="passwords.current">
          </div>
          <div class="mb-3">
            <label for="newPassword" class="form-label">Nueva Contraseña</label>
            <input type="password" class="form-control" id="newPassword" v-model="passwords.new">
          </div>
          <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirmar Nueva Contraseña</label>
            <input type="password" class="form-control" id="confirmPassword" v-model="passwords.confirm">
          </div>
          <button type="submit" class="btn btn-primary">Cambiar Contraseña</button>
        </form>
      </div>
    </div>

    <div class="card mt-4">
      <div class="card-header">
        Configuración de Tema
      </div>
      <div class="card-body">
        <p class="mb-3">Selecciona el tema de la aplicación:</p>
        <div class="theme-options">
          <div class="form-check mb-2">
            <input 
              class="form-check-input" 
              type="radio" 
              name="theme" 
              id="theme-blue" 
              value="blue" 
              v-model="selectedTheme"
              @change="cambiarTema"
            >
            <label class="form-check-label" for="theme-blue">
              <span class="theme-preview theme-blue"></span>
              Azul (Actual)
            </label>
          </div>
          <div class="form-check mb-2">
            <input 
              class="form-check-input" 
              type="radio" 
              name="theme" 
              id="theme-light" 
              value="light" 
              v-model="selectedTheme"
              @change="cambiarTema"
            >
            <label class="form-check-label" for="theme-light">
              <span class="theme-preview theme-light"></span>
              Claro
            </label>
          </div>
          <div class="form-check mb-2">
            <input 
              class="form-check-input" 
              type="radio" 
              name="theme" 
              id="theme-dark" 
              value="dark" 
              v-model="selectedTheme"
              @change="cambiarTema"
            >
            <label class="form-check-label" for="theme-dark">
              <span class="theme-preview theme-dark"></span>
              Oscuro
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/shared/services/auth';
import { useTheme } from '@/composables/useTheme';
import { useAccessControl } from '@/composables/useAccessControl';

export default {
  name: 'PerfilView',
  data() {
    return {
      usuario: null,
      passwords: {
        current: '',
        new: '',
        confirm: ''
      }
    };
  },
  
  setup() {
    // Variables de control de acceso - PerfilView requiere autenticación y permisos de menú
    const accessControl = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    });
    
    const { currentTheme, cambiarTema } = useTheme()
    
    return {
      ...accessControl,
      currentTheme,
      cambiarTema
    }
  },
  created() {
    const userData = authService.getUserData();
    if (userData && userData._UsuarioMo) {
      this.usuario = userData._UsuarioMo;
    }
  },
  methods: {
    async cambiarPassword() {
      if (this.passwords.new !== this.passwords.confirm) {
        alert('Las nuevas contraseñas no coinciden.');
        return;
      }
      
      // Aquí irá la lógica para llamar a la API
      alert('Funcionalidad de cambio de contraseña pendiente de implementación del backend.');
      
      // try {
      //   await api.post('/api/usuarios/cambiar-password', {
      //     passwordActual: this.passwords.current,
      //     nuevaPassword: this.passwords.new
      //   });
      //   alert('Contraseña cambiada con éxito');
      //   this.passwords = { current: '', new: '', confirm: '' };
      // } catch (error) {
      //   alert('Error al cambiar la contraseña.');
      // }
    },
    
    handleThemeChange(theme) {
      this.cambiarTema(theme);
    }
  }
};
</script>

<style scoped>
.perfil-view {
  max-width: 600px;
  margin: auto;
}

.theme-options .form-check-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.theme-options .form-check-label:hover {
  background-color: #f8f9fa;
}

.theme-preview {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
  border: 2px solid #dee2e6;
}

.theme-preview.theme-blue {
  background: linear-gradient(45deg, #007bff, #0056b3);
  border-color: #007bff;
}

.theme-preview.theme-light {
  background: linear-gradient(45deg, #f8f9fa, #6c757d);
  border-color: #6c757d;
}

.theme-preview.theme-dark {
  background: linear-gradient(45deg, #212529, #0d6efd);
  border-color: #495057;
}

.form-check-input:checked + .form-check-label {
  background-color: #e3f2fd;
  font-weight: 500;
}

.form-check-input:checked + .form-check-label .theme-preview {
  box-shadow: 0 0 0 2px #007bff;
}
</style>